var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.spinning}},[_c('div',{staticClass:"bg"},[_c('iframe',{staticStyle:{"width":"100vw","height":"100vh"},attrs:{"src":'/datascreen.html?baseURL='+_vm.baseURL+'&tenantName='+_vm.tenantName+'&echartsObj='+JSON.stringify(_vm.echartsObj),"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }